import { useMemo, useState } from "react";
import cls from "./AdminRecoveryPanel.module.scss";

const actionConfig = [
  {
    key: "skip",
    label: "Skip Active Turn",
    helper: "Move game forward if current turn is blocked.",
  },
  {
    key: "forceResult",
    label: "Force Result Handling",
    helper: "Push result resolution when turn is stuck.",
  },
  {
    key: "forcePenalty",
    label: "Force Resolve Penalty",
    helper: "Close unresolved penalty and restore flow.",
  },
  {
    key: "reset",
    label: "Reset Live State",
    helper: "Reset orphaned state and return to healthy loop.",
  },
];

export default function AdminRecoveryPanel({ health, readiness, onAction }) {
  const [reason, setReason] = useState("");

  const readinessFlags = useMemo(
    () => [
      {
        label: "Health",
        value: health?.needsRecovery ? "Needs Recovery" : "Healthy",
        danger: Boolean(health?.needsRecovery),
      },
      {
        label: "Turn Readiness",
        value: readiness?.canCreateNextTurn ? "Ready" : "Blocked",
        danger: !readiness?.canCreateNextTurn,
      },
      {
        label: "Players Ready",
        value: readiness?.readyPlayerCount ?? 0,
        danger: false,
      },
      {
        label: "Total Players",
        value: readiness?.totalPlayerCount ?? 0,
        danger: false,
      },
    ],
    [health?.needsRecovery, readiness],
  );

  const run = (key) => onAction?.(key, { reason: reason.trim() });

  return (
    <section className={cls.panel}>
      <div className={cls.header}>
        <div>
          <p className={cls.kicker}>ADMIN RECOVERY</p>
          <h3 className={cls.title}>Recovery Toolkit</h3>
          <p className={cls.subtitle}>
            Use safe fallback actions when turn flow gets stuck.
          </p>
        </div>
      </div>

      <div className={cls.statGrid}>
        {readinessFlags.map((item) => (
          <article className={cls.statCard} key={item.label}>
            <span className={cls.statLabel}>{item.label}</span>
            <strong className={item.danger ? cls.statDanger : cls.statValue}>
              {item.value}
            </strong>
          </article>
        ))}
      </div>

      <label className={cls.field}>
        <span className={cls.label}>Recovery Note</span>
        <textarea
          className={cls.textarea}
          placeholder="Optional reason stored with this admin action"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
      </label>

      <div className={cls.actionGrid}>
        {actionConfig.map((action) => (
          <button
            key={action.key}
            type="button"
            className={cls.actionBtn}
            onClick={() => run(action.key)}
          >
            <span className={cls.actionLabel}>{action.label}</span>
            <span className={cls.actionHelper}>{action.helper}</span>
          </button>
        ))}
      </div>
    </section>
  );
}
